import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc } from 'intact-react';
import { Button } from '../button';
import { Icon } from '../icon';
import { getRestProps } from '../utils';
import { isNullOrUndefined } from 'intact-shared';
var _$tmp0 = {
  'className': 'ion-ios-close-empty',
  'hoverable': true
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    value = _this$get.value,
    children = _this$get.children,
    className = _this$get.className,
    disabled = _this$get.disabled,
    closable = _this$get.closable;
  var _this$tabs$get = this.tabs.get(),
    currentValue = _this$tabs$get.value;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tab"] = true, _classNameObj[k + "-active"] = !isNullOrUndefined(value) && value === currentValue, _classNameObj[className] = className, _classNameObj[k + "-disabled"] = disabled, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-click': this.onClick
  }), [children, (isNullOrUndefined(closable) ? this.tabs.get('closable') : closable) ? _$cc(Button, {
    'type': 'none',
    'icon': true,
    'disabled': disabled,
    'size': 'mini',
    'className': _$cn(k + "-tab-close"),
    'ev-click': this.remove,
    'children': _$cc(Icon, _$tmp0)
  }) : undefined]);
}
;